import {navigateTo} from '@typed-router';
import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, useGuestHost, redirectToSignIn, useExtractQueryParameters, useUniversalFetch} from '#imports';

type SeoUrlResource = {
    url: string;
    urlWithoutInvariant: string;
};

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
    const host = useGuestHost();

    /**
     * When using Vitest environnement Nuxt, the global route middleware are executed.
     * For some reason since Nuxt 3.20.1, this middleware was blocking all the unit tests.
     * This condition is used to bypass the middleware when running unit tests.
     */
    if (import.meta.env.TEST === 'true') return;

    try {
        const queryParams = useExtractQueryParameters(to);
        // will throw a 403 error when unlogged (yep, 403...)
        const seoUrl = await useUniversalFetch<SeoUrlResource>('/api/url');
        return navigateTo(`${host}${seoUrl.url}?${queryParams}${to.hash}`, {external: true});
    } catch (error) {
        const redirectParam = to.fullPath + to.hash;
        return redirectToSignIn(redirectParam);
    }
});
